import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import { useAccount } from "wagmi";
import { useSigner } from "wagmi";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";
import { Toaster } from "react-hot-toast";
import Loading from "./Loading";
import { ToastContainer, toast } from "react-toastify";

// import jwt from 'jsonwebtoken';

const Verifyregistration = (props) => {
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const phonNo = localStorage.getItem("phone");
  const [emailOTP, setEmailOTP] = useState(null);
  const [phonOTP, setPhoneOTP] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { BigNumber } = require("ethers");
  const { address } = useAccount();
  const { data: signer } = useSigner();
  const plan = localStorage.getItem("plan");
  const packages = localStorage.getItem("package");
  let contract;
  if (signer) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      signer
    );
  }
  const submitUserDetails = async () => {
    try {
      setIsLoading(true);
      const resEmail = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/verify-email`,
        { email: email, otpCode: emailOTP }
      );
      const resPhone = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/verify-phone`,
        { number: phonNo, otpCode: phonOTP }
      );
      console.log("success Email", resEmail);
      console.log("sucess phone", resPhone);
      if (resEmail.data.success && resPhone.data.success) {
        
        toast("Sucess fully registered", resEmail.data.success, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // alert("Sucess fully registered", resEmail.data.success);
        console.log("Sucess fully registered", resPhone.data.success);
        localStorage.setItem("token", resPhone.data.Token);
        console.log("token", resPhone.data.Token);
        localStorage.setItem("email", "");
        localStorage.setItem("phone", "");
        // console.log("faheem",plan)
        await contract.subscribe(packages, { value: plan }).then((tx) =>
          tx.wait().then((res) => {
            axios
              .post(
                `${process.env.REACT_APP_SERVER_URL}/subscription`,
                {
                  subscription: `This subscription is buy in ${plan?.price}`,
                  address: res.events[1].address,
                  id: resPhone.data.id,
                  subType: packages==0?"small": packages==1?"medium":"large",
                  payment: ethers.utils.formatEther(plan.toString())

                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                console.log("Userrr", res);
                localStorage.setItem(
                  "userData",
                  JSON.stringify(res?.data?.user)
                );
                localStorage.setItem("token", res?.data?.Token);
                setIsLoading(false);
                navigate("/creator");
              });
          })
        );
      }
      if (!resEmail.data.success) {
        console.log("error", resEmail.data.msg);

        toast(resEmail.data.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // alert(resEmail.data.msg)
        setIsLoading(false);
      }
      //       if(!resPhone.data.success){
      //         console.log('error', resPhone.data.msg);
      //         alert(resEmail.data.msg)
      // setIsLoading(false)

      //       }
    } catch (error) {
      setIsLoading(false);
      toast(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      // alert(error);
      console.error("Error logging in:", error);
    }
  };
  console.log(isLoading);
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />

      <div
        className={"px-2 relative z-50 "}
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >

        <div
          className={`fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity`}
        ></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center ">
            <Loading isLoading={isLoading} />
            <div
              className={`relative bg-gradient-to-bl ${
                isLoading ? " blur-lg " : " "
              } from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2`}
            >
              <div
                className={`bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2`}
              >
                <div className="sm:flex sm:items-start">
                  <div className={`p-2 `}>
                    <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                      Verify
                    </h3>

                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-white dark:text-white"
                      >
                        Enter Email Verification Code
                      </label>
                      <input
                        type="text"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter Verification Code"
                        required
                        onChange={(e) => setEmailOTP(e.target.value)}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-white dark:text-white"
                      >
                        Enter Phone Verification Code
                      </label>
                      <input
                        type="text"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter Verification Code"
                        required
                        onChange={(e) => setPhoneOTP(e.target.value)}
                      />
                    </div>
                    {/* <div>
                        <label htmlFor="password" className="block mb-2 text-sm font-medium text-white dark:text-white">User Name</label>
                        <input type="text" name="text" id="text" placeholder="Username" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required/>
                    </div> */}


                    <button
                      data-modal-target="popup-modal"
                      data-modal-toggle="popup-modal"
                      // data-modal-hide="verification-modal"
                      type="submit"
                      className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      onClick={submitUserDetails}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>
              <button
                onClick={props.modalVerificationClose}
                type="button"
                className="mx-4 mb-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
              >
                Cancel
              </button>

            </div>
          </div>
        </div>
      </div>
      <Loading isLoading={isLoading} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default Verifyregistration;
